import { PathsManifest } from '@zg-rentals/paths-manifest';

const getAllPaths = (brand: string) => {
  const pathsManifest = new PathsManifest('/rental-manager', brand);
  return pathsManifest.getAllPaths();
};

// update with any new path patterns that need to be supported
// currently all pages with propertyId parameter have propertyId preceded by 'properties/' in the url
const LISTING_ALIAS_PATH_PREFIX_DELIMETERS = ['properties/'];

const RMW_SUB_PATH = {
  DASHBOARD: 'dashboard',
};

const RMW_PATH = {
  DASHBOARD_OVERVIEW: `${RMW_SUB_PATH.DASHBOARD}/overview`,
  DASHBOARD_LISTING: `${RMW_SUB_PATH.DASHBOARD}/listing`,
  DASHBOARD_APPLICATIONS: `${RMW_SUB_PATH.DASHBOARD}/applications`,
  DASHBOARD_LEASES: `${RMW_SUB_PATH.DASHBOARD}/leases`,
  DASHBOARD_PAYMENTS: `${RMW_SUB_PATH.DASHBOARD}/payments`,
  DASHBOARD_MAINTENANCE_TASKS: `${RMW_SUB_PATH.DASHBOARD}/maintenance-tasks`,
  PREMIUM_ANALYTICS: 'premium-analytics',
  LISTING_CLAIMING: '/rental-manager/listing-claiming',
  IP_CHECK_PAGE: '/rental-manager/ip',
  LISTING_CLAIMING_HELP: '/corp/Terms.htm', // @TODO fix once we know the url
};

const RMW_DASHBOARD_ACCEPTED_PATHS = [
  RMW_PATH.DASHBOARD_OVERVIEW,
  RMW_PATH.DASHBOARD_LISTING,
  RMW_PATH.DASHBOARD_APPLICATIONS,
  RMW_PATH.DASHBOARD_LEASES,
  RMW_PATH.DASHBOARD_PAYMENTS,
  RMW_PATH.DASHBOARD_MAINTENANCE_TASKS,
];

/**
 *
 * @param pathObj - a key/value object containing a path map with a sub path
 *  ex: dashboard/overview
 * @param subPathBase - the key of the sub path
 *  ex: dashboard
 *
 * @returns {Array} - a list of paths that match the subPathBase
 *  ex: [dashboard/overview, dashboard/listing]
 */
const getSubPathList = ({ pathObj = {}, subPathBase }: { pathObj: object; subPathBase: string }) => {
  const response = Object.values(pathObj).filter((value) => {
    return value.includes(subPathBase);
  });

  return response;
};

const getGenericApplicationUrl = (host: string, listingAlias: string) => {
  return `https://${host}/renter-hub/applications/listing/${listingAlias}/rental-application?utm_source=sohapplicationshare&utm_medium=desktopmweb&utm_campaign=applicationlinkshare`;
};

export { getSubPathList, LISTING_ALIAS_PATH_PREFIX_DELIMETERS, RMW_PATH, RMW_SUB_PATH, RMW_DASHBOARD_ACCEPTED_PATHS };

export default {
  getAllPaths,
  getGenericApplicationUrl,
};
